export default class DashboardInfo {
	countBids?: number;
    countNewBids?: number;
    countInProgressBids?: number;
    countUnconfirmedBids?: number;
    countClosedBids?: number;
}